import { Request } from "../base/models.jsx";
import { MetaDataBin } from "../../utils/bins/models.jsx";
import { Place } from "../../map/places/models.jsx";
import Url from "../../utils/validators/url"

const SERVICE_ID = 9;

class Advertisement extends Request {

	constructor(jsonData) {
		if (jsonData == null) {
			jsonData = {};
			super(jsonData);
			this.creation();
		} else {
			super(jsonData);
		}

		this.title = jsonData.title
		this.body = jsonData.body
		this.binId = jsonData.binId;
		this.url = jsonData.url;
		this.placeId = jsonData.placeId;
		this.startDate = jsonData.startDate ? jsonData.startDate : null;
		this.endDate = jsonData.endDate ? jsonData.endDate : null;

		if (jsonData.place)
			this.place = new Place(jsonData.place);
		if (jsonData.bin)
			this.bin = new MetaDataBin(jsonData.bin)

	}

	creation() {
		super.creation();
		this.serviceId = SERVICE_ID;
	}

	isValid() {
		if (!this.title || !this.title.trim())
			return false;

		if (!this.body || !this.body.trim())
			return false;

		if (!this.startDate || !this.endDate || this.startDate > this.endDate)
			return false;

		if (!this.placeId)
			return false;

		if (this.url && !Url.isValid(this.url))
			return false;

		return true;
	}

}

export {Advertisement};
